<template>
  <div>
    <b-modal
      id="assign-order-teams"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('AssignOrder')"
      hide-footer
      @close="onCancel"
    >
      <b-form>
        <b-form-group
          :label="$t('Orders')"
        >
          <vue-select
            v-model="assignedOrders"
            :placeholder="$t('SelectTeam')"
            :options="allOrders"
            label="orderNumber"
            :multiple="true"
          />
        </b-form-group>
        <p
          v-if="buttonSubmited == true && assignedOrders.length == 0"
          style="color:red;margin-top: 10px;"
        >
          {{ $t('SelectOneOrder') }}
        </p>
        <b-form-group
          :label="$t('AssignTeam')"
        >
          <vue-select
            v-model="assignTeam"
            :placeholder="$t('SelectTeam')"
            :options="getTeamsNames"
            label="teamName"
            :reduce="(e) => e.teamNameId"
          />
        </b-form-group>
        <p
          v-if="buttonSubmited == true && assignTeam == null"
          style="color:red;margin-top: 10px;"
        >
          {{ $t('SelectTeam') }}
        </p>
        <div class="buttonsEverywhere">
          <button
            type="button"
            variant="none"
            class="buttonSubmit"
            style="margin-top: 10px;"

            @click="onSubmit"
          >
            {{ $t('Submit') }}
          </button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 15px; margin-top: 10px; background: white; color: black; border-color: white; font-weight: 400;"

            @click="onCancel"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: ['selectedOrders'],
  data() {
    return {
      buttonSubmited: false,
      assignTeam: null,
      allOrders: [],
      assignedOrders: [],
    }
  },
  computed: {
    ...mapGetters([
      'getTeamsNames',
    ]),

  },
  watch: {
    selectedOrders(value) {
      this.allOrders = value.map((item) => {
        return {
          orderNumber: `${item.orderNumber} - ${item.articleNumber}`,
          articleNumber: item.articleNumber,
          orderItemId: item.orderItemId,
        }
      })
      this.assignedOrders = value.map((item) => {
        return {
          orderNumber: `${item.orderNumber} - ${item.articleNumber}`,
          articleNumber: item.articleNumber,
          orderItemId: item.orderItemId,
        }
      })
    },
  },
  methods: {
    onSubmit() {
      this.buttonSubmited = true
      try {
        if (this.buttonSubmited == true && this.assignTeam == null) {
          return
        }
        if (this.buttonSubmited == true && this.assignedOrders.length == 0) {
          return
        }
        const object = {
          assignmentTeamNameId: this.assignTeam,
          orderItemIds: this.assignedOrders.map((item) => {
            return item.orderItemId
          }),
          // newState: 'Assigned',
        }
        this.$emit('assignTeams', object)
        this.$refs.modal.hide();
        this.onReset()
      } catch (error) {
        console.log(error)
      }
    },
    onCancel() {
      this.$refs.modal.hide();
      this.onReset()
    },
    onReset() {
      this.buttonSubmited = false
      this.assignTeam = null
    },
  },
}
</script>
